"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCalendarBackNavigation = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const urls_1 = require("../const/urls");
const hooks_1 = require("../store/hooks");
const movingCalendarStreamSlice_1 = require("../store/movingCalendarStreamSlice");
const userStates_1 = require("../types/userStates");
const mapParamsHandler_1 = require("../utils/mapParamsHandler");
const useScreenSizeDetection_1 = __importDefault(require("../utils/useScreenSizeDetection"));
const useCalendarBackNavigation = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const dispatch = (0, hooks_1.useAppDispatch)();
    const { currentUserSettings, previousUserSettings, searchParams } = (0, mapParamsHandler_1.useMapParams)();
    const handleCalendarGoBack = (0, react_1.useCallback)(() => {
        if (currentUserSettings === userStates_1.UserSettings.CalendarView) {
            dispatch((0, movingCalendarStreamSlice_1.resetMovingStreamData)());
        }
        const newSearchParams = new URLSearchParams(searchParams.toString());
        newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.previousUserSettings, currentUserSettings);
        newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.currentUserSettings, previousUserSettings);
        if (isMobile) {
            newSearchParams.delete(mapParamsHandler_1.UrlParamsTypes.streamId);
            newSearchParams.delete(mapParamsHandler_1.UrlParamsTypes.sessionId);
        }
        navigate(`${urls_1.urls.reactMap}?${newSearchParams.toString()}`);
    }, [
        currentUserSettings,
        navigate,
        previousUserSettings,
        searchParams,
        isMobile,
    ]);
    return handleCalendarGoBack;
};
exports.useCalendarBackNavigation = useCalendarBackNavigation;
